import React from 'react';
import { Link } from 'react-router-dom';

export interface DetailPageFrameProps {
  backHref: string;
  backLabel?: string;
  identity: React.ReactNode;
  status?: React.ReactNode;
  metrics?: React.ReactNode;
  tabs?: React.ReactNode;
  stickyTabs?: boolean;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

const DetailPageFrame: React.FC<DetailPageFrameProps> = ({
  backHref,
  backLabel = 'Back',
  identity,
  status,
  metrics,
  tabs,
  stickyTabs,
  actions,
  children,
}) => (
  <div className="min-w-0 space-y-6">
    <Link
      to={backHref}
      className="inline-flex min-h-11 items-center rounded-md px-2 text-sm font-semibold text-club-blue-700 transition-colors hover:bg-club-blue-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 motion-reduce:transition-none dark:text-club-blue-300 dark:hover:bg-club-blue-950"
    >
      {backLabel}
    </Link>
    <header className="rounded-xl bg-white p-5 shadow-sm ring-1 ring-gray-200 dark:bg-gray-900 dark:ring-gray-800 sm:p-6">
      <div className="flex min-w-0 flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0 space-y-3">
          {identity}
          {status}
        </div>
        {actions && <div aria-label="Detail actions" role="group" className="flex flex-wrap gap-2">{actions}</div>}
      </div>
      {metrics && <div className="mt-5">{metrics}</div>}
      {tabs && !stickyTabs && <div className="mt-5 border-t border-gray-200 pt-4 dark:border-gray-700">{tabs}</div>}
    </header>
    {tabs && stickyTabs && <div className="sticky top-16 z-10 rounded-xl bg-white p-2 shadow-sm ring-1 ring-gray-200 dark:bg-gray-900 dark:ring-gray-800">{tabs}</div>}
    <div className="min-w-0 space-y-6">{children}</div>
  </div>
);

export default DetailPageFrame;
